import { apiClientManager } from '@common/api';
export function fetchThirdPartyLicenses() {
    return apiClientManager
        .getClient()
        .get('/api/info/third-party-licenses')
        .then(({ data }) => data);
}
